import axios from "axios";

const postReport = async (baseUrl, token, doctorId, appointmentId, report) => {

    //{{uri}}/doctor/{{doctorid}}/appointment/118/report
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let postResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/report", report, config)
        .then((res) => {
            postResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                postResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return postResponse
}

export default postReport;